import {defineAsyncComponent} from 'vue';

const ReportPrintPreview = defineAsyncComponent(() => import('@/views/report/ReportPrintPreview.vue'));

const StaticReportPrintPreview = defineAsyncComponent(() => import('@/views/report/StaticReportPrintPreview.vue'));

const DynamicReportPrintPreview = defineAsyncComponent(() => import('@/views/report/DynamicReportPrintPreview.vue'));

const ReportDesigner = defineAsyncComponent(() => import('@/views/report/ReportDesigner.vue'));
const CoverReportDesigner = defineAsyncComponent(() => import('@/views/report/CoverReportDesigner.vue'));

const ReportDesignerConfirmPopup = defineAsyncComponent(() => import('@/views/report/ReportDesignerConfirmPopup.vue'));

const ReportMergePopup = defineAsyncComponent(() => import('@/views/report/reportMerge/ReportMergePopup.vue'));

const ReportMergeDetailPopup = defineAsyncComponent(() =>
  import('@/views/report/reportMerge/ReportMergeDetailPopup.vue'),
);

const SortDataVoucherReport = defineAsyncComponent(() =>
  import('@/views/report/parameters/voucherReport/SortDataVoucherReport/SortDataVoucherReport.vue'),
);

export function registerReport(app) {
  app.component('StaticReportPrintPreview', StaticReportPrintPreview);
  app.component('DynamicReportPrintPreview', DynamicReportPrintPreview);
  app.component('ReportDesigner', ReportDesigner);
  app.component('CoverReportDesigner', CoverReportDesigner);
  app.component('ReportPrintPreview', ReportPrintPreview);
  app.component('ReportMergePopup', ReportMergePopup);
  app.component('ReportMergeDetailPopup', ReportMergeDetailPopup);
  app.component('SortDataVoucherReport', SortDataVoucherReport);
  app.component('ReportDesignerConfirmPopup', ReportDesignerConfirmPopup);
}
